import { api } from "@/api";
import { QueryConfig, QueryResult } from "@/shared/types/base";
import { Permiso } from "@/shared/types/permiso";
import { sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function getUsuarioPermisos(usuarioId: string): Promise<Permiso[]> {
    await sleep(1000);
    const response = await api.get("permisos/" + usuarioId);
    return response.data;
}

export function useGetUsuarioPermisosQuery(usuarioId: string, queryConfig: QueryConfig<Permiso[]> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: () => getUsuarioPermisos(usuarioId),
        queryKey: ["permisos", usuarioId],
    })
}

export interface GetUsuarioPermisosQueryProps {
    usuarioId: string,
    queryConfig?: QueryConfig<Permiso[]>,
    children?: (queryResult: QueryResult<Permiso[]>) => ReactNode
}

export function GetUsuarioPermisosQuery({
    usuarioId,
    children,
    queryConfig
}: GetUsuarioPermisosQueryProps) {
    const queryResult = useGetUsuarioPermisosQuery(usuarioId, queryConfig);
    return children && children(queryResult);
}
